import React, { ReactNode } from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'src/shared/components/ui/dropdown-menu';
import { MoreVertical } from 'lucide-react';

export type MenuAction = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    icon?: ReactNode;
};

export type MoreActionsMenuProps = {
    actions: MenuAction[];
    testId?: string;
    side?: 'top' | 'right' | 'bottom' | 'left';
    align?: 'start' | 'center' | 'end';
    buttonClassName?: string;
};

const MoreActionsMenu = (props: MoreActionsMenuProps) => {
    const { actions, testId = 'more-actions-menu', side = 'right', align = 'start', buttonClassName = '' } = props;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className={`p-2 rounded-md hover:bg-teal-20 data-[state=open]:bg-teal-20 transition-colors ${buttonClassName}`}
                    aria-label='More actions'
                    data-testid={testId}
                >
                    <MoreVertical className='w-5 h-5 text-primary' />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side={side} align={align} className='min-w-[180px] border border-primary rounded-lg shadow-lg'>
                {actions.map((action, index) => (
                    <DropdownMenuItem
                        key={index}
                        onClick={action.onClick}
                        disabled={action.disabled}
                        className='flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-grey-10 focus:bg-grey-10'
                    >
                        {action.icon && <span className='w-5 h-5 flex items-center justify-center'>{action.icon}</span>}
                        <span>{action.label}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default MoreActionsMenu;
